import { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import { fetchActivities } from '../services/fetchActivities';
const Logs = () => {
    const { token, base_url, activities, setActivities, history, setHistory } = useAppContext();
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('');

    useEffect(() => {
        fetchActivities(token, base_url, history, setActivities);
    }, [token, base_url, history, setActivities]);

    const filteredActivities = activities.filter((log) => {
        const matchesSearch = log.deal_id.toString().includes(searchTerm.toString());

        const matchesStatus = (() => {
            if (!statusFilter) return true;
            if (statusFilter === '200') return log.status_code.toString() === '200';
            if (statusFilter === '400') return log.status_code.toString() !== '200' && log.status_code.toString() !== '201' && log.status_code.toString() !== '202';
            if (statusFilter === '201') return log.status_code.toString() === '201' || log.status_code.toString() === '202';
            return false;
        })();

        return matchesSearch && matchesStatus;
    });

    const formatDate = (date) => {
        const d = new Date(date)
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} | ${hours}:${minutes}`;
    };

    const getStatusColor = (status) => {
        if (status === 200) return '#40f2cb';
        if (status === 201) return '#f8f1a6';
        if (status === 202) return '#f8f1a6';
        return '#e65a50';
    };

    return (
        <div>
            <div className="content-header">
                <h1>Advanced Logs</h1>
                <hr />
            </div>

            <div className="overview-content" style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', marginBottom: '20px' }}>
                <input
                    type="text"
                    placeholder="Search by Deal ID (end of Hubspot URL on deal page)"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ flex: '2' }}
                    />

                <select style={{ flex: '1' }} value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                    <option value="">Filter by Status</option>
                    <option value="200">Success</option>
                    <option value="400">Error</option>
                    <option value="201">Pending</option>
                </select>

                <div style={{ display: 'flex', gap: '5px' }}>
                    {[30, 90, 180, 1000].map((range) => (
                        <button 
                            key={range} 
                            onClick={() => setHistory(range)}
                            style={{
                                padding: '10px 20px',
                                background: history === range ? '#40f2cb' : '#cccccc',
                                color: '#111827',
                                textAlign: 'left',
                                cursor: 'pointer',
                                borderRadius: '4px',
                                transition: 'background-color 0.3s, color 0.3s',
                                border: '2px solid #111827'
                            }}
                            onMouseEnter={(e) => {
                                if (history !== range) {
                                    e.target.style.backgroundColor = '#8e8e8e';
                                    e.target.querySelector('h6').style.backgroundColor = '#8e8e8e';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (history !== range) {
                                    e.target.style.backgroundColor = '#cccccc';
                                    e.target.querySelector('h6').style.backgroundColor = '#cccccc';
                                }
                            }}
                        >
                            <h6 style={{ 
                                margin: '0',
                                backgroundColor: history === range ? '#40f2cb' : '#cccccc',
                                transition: 'background-color 0.3s'
                            }}>{range === 1000 ? 'All' : `${range} Days`}</h6>
                        </button>
                    ))}
                </div>
            </div>

            <div>
                <table className="activities-table">
                    <thead>
                        <tr>
                        <th style={{width: '175px'}}>Date</th>
                        <th style={{width: '140px'}}>Deal ID</th>
                        <th style={{width: '100px'}}>Status</th>
                        <th>Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredActivities.sort((a, b) => new Date(b.create_date) - new Date(a.create_date)).map((log, index) => (
                            <tr key={index} style={index % 2 === 0 ? {background: '#e6e6e6'} : {background: '#fff'}}>
                                <td>{formatDate(log.create_date)}</td>
                                <td>{log.deal_id}</td>
                                <td>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '8px'}}>
                                        <span style={{height: '12px', width: '12px', background: `${getStatusColor(log.status_code)}`, borderRadius: '2px', marginRight: '5px', border: '1px solid #111827'}}></span>
                                        <span style={{color: '#111827'}}>{log.status_code}</span>
                                    </div>
                                </td>
                                <td>{log.msg}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div style={{ width: '100%', textAlign: 'center', marginTop: '100px' }}>
                    { filteredActivities.length === 0 && ( <p>No logs found.</p> )}
                </div>
            </div>
        </div>
    );
};

export default Logs;